import React, { useEffect, useMemo } from 'react'
import { Stack, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { useSplitClient } from '@splitsoftware/splitio-react'
import PropTypes from 'prop-types'
import * as Sentry from '@sentry/react'

const Page404 = ({ homeRoute, routesAreReady }) => {
  const navigate = useNavigate()
  const { client: splitClient } = useSplitClient()
  const canShow404 = useMemo(() => {
    const splitClientAttributes = splitClient?.getAttributes()
    return (
      routesAreReady &&
      !!splitClientAttributes?.organizationId &&
      !!splitClientAttributes?.userId &&
      !!splitClientAttributes?.yardId
    )
  }, [splitClient, routesAreReady])

  const gotoHomeScreen = () => {
    navigate(homeRoute)
  }

  useEffect(() => {
    if (!canShow404) return
    Sentry.captureException(new Error(`404 error: ${window.location.pathname} path does not exist`))
  }, [canShow404])

  return (
    <Stack py={20} alignItems="center">
      {canShow404 ? (
        <>
          <Typography variant="h2">404 Error</Typography>
          <Typography variant="h4" my={2}>
            Oops! Page Not Found
          </Typography>
          <Typography variant="h5" align="center">
            You can either return to the previous page,
            <br />
            visit our homepage, or contact our support team
          </Typography>
          <Stack mt={5} direction="row" spacing={3}>
            <Button variant="contained" onClick={gotoHomeScreen}>
              Return to Home Screen
            </Button>
            <Button
              component="a"
              variant="outlined"
              target="_blank"
              href="mailto:support@greensparksoftware.zendesk.com"
            >
              Contact Support
            </Button>
          </Stack>
        </>
      ) : null}
    </Stack>
  )
}

Page404.propTypes = {
  homeRoute: PropTypes.string,
  routesAreReady: PropTypes.bool,
}

Page404.defaultProps = {
  homeRoute: '',
  routesAreReady: false,
}

export default Page404
